import { render } from "./RegisterExpressView.vue?vue&type=template&id=429f7556"
import script from "./RegisterExpressView.vue?vue&type=script&lang=js"
export * from "./RegisterExpressView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__